import styled from 'styled-components'

import { SpacingOption, verticalChildSpacing } from 'components/utils/spacing'

const VerticalSpacer = styled.div<{ gap: SpacingOption }>`
  ${({ gap }) => verticalChildSpacing[gap]}
`

export default VerticalSpacer
